module.exports = __webpack_public_path__ + "img/panoptik.7f01a2c0.jpg";